ALLOWED_CONTROLLER = 'ui_nodes'
ALLOWED_ACTIONS = ['index']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)

  autocomplete_source= ->
    locations_data = $('*[data-selector="ui_nodes_filter"]').data('locationsSource')
    owners_data = $('*[data-selector="ui_nodes_filter"]').data('ownersSource')

    if $('*[data-selector="ui_nodes_filter_by"]').val() == "locations.name"
      locations_data
    else
      owners_data

  $('*[data-selector="ui_nodes_filter"]').autocomplete
    source: autocomplete_source()

  $('*[data-selector="ui_nodes_filter_by"]').on 'change', ->
    $('*[data-selector="ui_nodes_filter"]').autocomplete
      source: autocomplete_source()

$(document).ready(ready)
$(document).on('turbo:load', ready)
